export const mutations = {
    GET_COUNTRIES: 'GET_COUNTRIES'
};

export const actions = {
    INIT_STORE: 'INIT_STORE',
    GET_COUNTRIES: 'GET_COUNTRIES'
};